import { useState } from 'react';

import { BottomSheet } from '@/components/BottomSheet';

import { useDeleteAccount } from './useDeleteAccount';

/**
 * Удаление аккаунта.
 *
 * Необратимое действие получает лишний шаг подтверждения — в отличие,
 * например, от удаления одной генерации: там цена ошибки один результат,
 * здесь — весь баланс, история и реферальные связи разом.
 */
export function DeleteAccountSection() {
  const [confirming, setConfirming] = useState(false);
  const deleteAccount = useDeleteAccount();

  return (
    <section className="flex flex-col gap-3 border-t border-border px-6 py-6">
      <h2 className="text-lg font-semibold text-text">Удаление аккаунта</h2>
      <p className="text-sm text-text-2">
        Удаляются безвозвратно: баланс, история генераций и фотосессий, избранное, приглашения и
        связанные аккаунты Telegram/VK. Отменить нельзя.
      </p>

      <button
        type="button"
        onClick={() => setConfirming(true)}
        className="self-start rounded-xl border border-danger px-4 py-2 text-sm text-danger hover:bg-danger/10"
      >
        Удалить аккаунт
      </button>

      {confirming && (
        <BottomSheet
          title="Удалить аккаунт навсегда?"
          hint="Это действие нельзя отменить."
          onClose={() => setConfirming(false)}
        >
          <div className="flex flex-col gap-3">
            {deleteAccount.isError && (
              <p className="text-sm text-danger">Не удалось удалить аккаунт. Попробуйте ещё раз.</p>
            )}

            <button
              type="button"
              onClick={() => deleteAccount.mutate()}
              disabled={deleteAccount.isPending}
              className="w-full rounded-xl bg-danger px-4 py-3 font-medium text-on-danger disabled:opacity-50"
            >
              {deleteAccount.isPending ? 'Удаляем…' : 'Да, удалить всё'}
            </button>
          </div>
        </BottomSheet>
      )}
    </section>
  );
}
